import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { FadeUp, rich } from "./Reveal";

export default function HomeIntro() {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <section id="chi-siamo" data-testid="home-intro" className="py-28 md:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-7">
          <FadeUp>
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-12 bg-brass" />
              <p className="eyebrow">{t.home.eyebrow}</p>
            </div>
          </FadeUp>
          <FadeUp delay={0.08}>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.12] tracking-tight text-cream">
              {rich(t.about.title)}
            </h2>
          </FadeUp>
          <FadeUp delay={0.16}>
            <p className="mt-6 max-w-2xl text-stone font-light leading-relaxed text-base lg:text-lg">
              {t.about.p1}
            </p>
          </FadeUp>
        </div>
        <div className="lg:col-span-5 lg:pl-10 flex lg:flex-col gap-4 lg:gap-5">
          <FadeUp delay={0.2} className="flex-1 lg:flex-none">
            <button
              data-testid="home-intro-team"
              onClick={() => { navigate("/chi-siamo"); window.scrollTo(0, 0); }}
              className="w-full lg:w-auto inline-flex items-center justify-between gap-6 border border-cream/25 px-7 py-4 text-[12px] uppercase tracking-[0.18em] text-cream hover:border-brass hover:text-brass transition-colors duration-500"
            >
              {t.home.teamCta} <ArrowRight size={15} />
            </button>
          </FadeUp>
          <FadeUp delay={0.28} className="flex-1 lg:flex-none">
            <button
              data-testid="home-intro-works"
              onClick={() => { navigate("/works"); window.scrollTo(0, 0); }}
              className="w-full lg:w-auto inline-flex items-center justify-between gap-6 border border-cream/25 px-7 py-4 text-[12px] uppercase tracking-[0.18em] text-cream hover:border-brass hover:text-brass transition-colors duration-500"
            >
              {t.home.worksCta} <ArrowRight size={15} />
            </button>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
